<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Tipos de Atendimento</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pb-0 pt-0">
        <div class="d-flex justify-space-between mb-2">
          <v-btn id="tiposAtendimento.criarBtn" color="primary" dark @click="abrirCriar">
            <v-icon left small>mdi-plus</v-icon>
            Criar tipo de atendimento
          </v-btn>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-2 search-input"
            dense
            hide-details
            label="Pesquisar..."
            single-line
            solo
          />
        </div>
      </v-col>

      <v-col class="pt-0">
        <v-data-table
          :headers="tableHeaders"
          :items="tiposList"
          :items-per-page="10"
          :loading="isLoading"
          :search="search"
          class="elevation-1"
          no-data-text="Nenhum tipo de atendimento encontrado"
        >
          <template v-slot:[`item.categoria`]="{ item }">
            {{ labelCategoria(item.categoria) }}
          </template>

          <template v-slot:[`item.apenas_para_alunos`]="{ item }">
            <v-chip small :color="item.apenas_para_alunos ? 'primary' : 'grey lighten-1'" dark>
              {{ item.apenas_para_alunos ? "Sim" : "Não" }}
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ml-1"
                  color="blue-grey lighten-3"
                  x-small
                  @click="() => abrirEditar(item)"
                >
                  <v-icon small>fa fa-edit</v-icon>
                </v-btn>
              </template>
              <span>Editar tipo de atendimento</span>
            </v-tooltip>

            <v-tooltip bottom color="error">
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ml-1"
                  color="error"
                  x-small
                  @click="() => deletar(item)"
                >
                  <v-icon small>fa fa-trash</v-icon>
                </v-btn>
              </template>
              <span>Apagar tipo de atendimento</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="520" persistent>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-card>
          <v-card-title class="primary white--text">
            {{ editando ? "Editar" : "Novo" }} tipo de atendimento
          </v-card-title>

          <v-card-text class="pt-4">
            <ValidationProvider
              name="Código"
              :rules="{ required: true, numeric: true, max_chars: 10 }"
              v-slot="{ errors }"
            >
              <v-text-field
                id="tiposAtendimento.codigo"
                ref="codigoField"
                v-model="form.codigo"
                @input="onCodigoInput"
                label="Código"
                outlined
                dense
                counter="10"
                maxlength="10"
                :error-messages="codigoErro || errors"
              />
            </ValidationProvider>

            <ValidationProvider
              name="Descrição"
              :rules="{ required: true, no_special_chars_strict: true, max_chars: 50 }"
              v-slot="{ errors }"
            >
              <v-text-field
                id="tiposAtendimento.descricao"
                ref="descricaoField"
                v-model="form.descricao"
                @input="onDescricaoInput"
                @beforeinput="(e) => bloquearEspeciais(e, 'descricaoErro')"
                label="Descrição"
                outlined
                dense
                counter="50"
                maxlength="50"
                :error-messages="descricaoErro || errors"
              />
            </ValidationProvider>

            <ValidationProvider name="Categoria" rules="required" v-slot="{ errors }">
              <v-select
                id="tiposAtendimento.categoria"
                v-model="form.categoria"
                :items="categorias"
                item-text="text"
                item-value="value"
                label="Categoria"
                outlined
                dense
                hint="Define quais campos extras o formulário de atendimento exibirá (Curso, Habilidades ou Disciplina)."
                persistent-hint
                :error-messages="errors"
              >
                <template #item="{ item }">
                  <span :id="`tiposAtendimento.categoria.${item.value}`">{{ item.text }}</span>
                </template>
              </v-select>
            </ValidationProvider>

            <v-switch
              id="tiposAtendimento.apenasParaAlunos"
              class="mt-4"
              v-model="form.apenas_para_alunos"
              color="primary"
              label="Apenas para alunos"
              hint="Quando marcado, influencia os formulários de atendimento (público-alvo somente alunos)."
              persistent-hint
              inset
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="fecharDialog">Cancelar</v-btn>
            <v-btn
              id="tiposAtendimento.salvarBtn"
              :color="invalid || temErroLocal ? 'grey lighten-1' : 'amber darken-2'"
              :dark="!invalid && !temErroLocal"
              :disabled="invalid || temErroLocal"
              :loading="salvando"
              @click="salvar"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "TiposDeAtendimentoPage",

  data() {
    return {
      isLoading: false,
      salvando: false,
      search: "",
      dialog: false,
      editando: false,
      codigoErro: "",
      descricaoErro: "",
      tiposList: [],
      form: this.formPadrao(),
      categorias: [
        { value: "curso", text: "Curso (AVAMEC/EV.GOV)" },
        { value: "caee", text: "CAEE" },
        { value: "biblioteca", text: "Biblioteca" },
        { value: "recomposicao", text: "Recomposição de Aprendizagem" },
        { value: "outro", text: "Outro" },
      ],
      tableHeaders: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Categoria", value: "categoria" },
        { text: "Apenas para alunos", value: "apenas_para_alunos" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },

  computed: {
    temErroLocal() {
      return Boolean(this.codigoErro || this.descricaoErro);
    },
  },

  mounted() {
    this.listar();
  },

  methods: {
    formPadrao() {
      return { id: null, codigo: "", descricao: "", categoria: "outro", apenas_para_alunos: false };
    },

    labelCategoria(valor) {
      const cat = this.categorias.find((c) => c.value === valor);
      return cat ? cat.text : valor;
    },

    aplicarValorSaneado(ref, campo, limpo) {
      this.form[campo] = limpo;
      const field = this.$refs[ref];
      if (!field) return;
      field.lazyValue = limpo;
      const input = field.$refs.input;
      if (input && input.value !== limpo) input.value = limpo;
    },

    bloquearEspeciais(evento, campoErro) {
      const texto = evento.data ?? evento.dataTransfer?.getData("text") ?? "";
      if (!texto || !this.$temCaractereEspecial(texto)) return;
      evento.preventDefault();
      this[campoErro] = "Não são permitidos emojis ou caracteres especiais inválidos";
    },

    onCodigoInput(valor) {
      const limpo = this.$somenteNumeros(valor);
      this.codigoErro = limpo !== (valor || "") ? "O campo Código deve conter apenas números" : "";
      this.aplicarValorSaneado("codigoField", "codigo", limpo);
    },

    onDescricaoInput(valor) {
      const limpo = this.$semCaracteresEspeciais(valor);
      this.descricaoErro =
        limpo !== (valor || "")
          ? "Não são permitidos emojis ou caracteres especiais inválidos"
          : "";
      this.aplicarValorSaneado("descricaoField", "descricao", limpo);
    },

    async listar() {
      this.isLoading = true;
      try {
        this.tiposList = await this.$services.tiposDeAtendimentoService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
      this.isLoading = false;
    },

    abrirCriar() {
      this.editando = false;
      this.form = this.formPadrao();
      this.codigoErro = "";
      this.descricaoErro = "";
      this.dialog = true;
      this.$nextTick(() => this.$refs.observer && this.$refs.observer.reset());
    },

    abrirEditar(tipo) {
      this.editando = true;
      this.form = {
        id: tipo.id,
        codigo: tipo.codigo,
        descricao: this.$semCaracteresEspeciais(tipo.descricao),
        categoria: tipo.categoria || "outro",
        apenas_para_alunos: Boolean(tipo.apenas_para_alunos),
      };
      this.codigoErro = "";
      this.descricaoErro = "";
      this.dialog = true;
      this.$nextTick(() => this.$refs.observer && this.$refs.observer.reset());
    },

    fecharDialog() {
      this.dialog = false;
    },

    async salvar() {
      const valido = await this.$refs.observer.validate();
      if (!valido) return;

      this.salvando = true;
      try {
        const payload = {
          ...this.form,
          codigo: this.$somenteNumeros(this.form.codigo),
          descricao: this.$semCaracteresEspeciais(this.form.descricao),
        };
        if (this.editando) {
          await this.$services.tiposDeAtendimentoService.atualizar(payload);
          this.$toast.success("Tipo de atendimento atualizado com sucesso");
        } else {
          await this.$services.tiposDeAtendimentoService.criar(payload);
          this.$toast.success("Tipo de atendimento criado com sucesso");
        }
        this.dialog = false;
        await this.listar();
      } catch (error) {
        this.$handleError(error);
      }
      this.salvando = false;
    },

    deletar(tipo) {
      this.$modals.danger({
        buttons: [
          {
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
            text: "Cancelar",
          },
          {
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando tipo de atendimento");
              try {
                await this.$services.tiposDeAtendimentoService.deletar(tipo);
                this.$toast.success("Tipo de atendimento deletado com sucesso");
                await this.listar();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            disableIfCodeDoesntMatch: true,
            props: { color: "error", small: true },
            text: "Confirmar",
          },
        ],
        confirmationCode: String(tipo.codigo),
        confirmationMessage: `Por favor, digite <strong>${tipo.codigo}</strong> para confirmar`,
        message: "Tem certeza que deseja apagar este tipo de atendimento?",
        title: "Cuidado!",
      });
    },
  },
};
</script>

<style scoped></style>
